export const currencyNameMapEn = new Map<string, string>(
    [
        ['AED', 'AED - United Arab Emirates dirham'],
        ['AFN', 'AFN - Afghan afghani'],
        ['ALL', 'ALL - Albanian lek'],
        ['AMD', 'AMD - Armenian dram'],
        ['ANG', 'ANG - Netherlands Antillean guilder'],
        ['AOA', 'AOA - Angolan kwanza'],
        ['ARS', 'ARS - Argentine peso'],
        ['AUD', 'AUD - Australian dollar'],
        ['AWG', 'AWG - Aruban florin'],
        ['AZN', 'AZN - Azerbaijani manat'],
        ['BAM', 'BAM - Bosnia and Herzegovina convertible mark'],
        ['BBD', 'BBD - Barbadian dollar'],
        ['BDT', 'BDT - Bangladeshi taka'],
        ['BGN', 'BGN - Bulgarian lev'],
        ['BHD', 'BHD - Bahraini dinar'],
        ['BIF', 'BIF - Burundian franc'],
        ['BMD', 'BMD - Bermudian dollar'],
        ['BND', 'BND - Brunei dollar'],
        ['BOB', 'BOB - Bolivian boliviano'],
        ['BRL', 'BRL - Brazilian real'],
        ['BSD', 'BSD - Bahamian dollar'],
        ['BTN', 'BTN - Bhutanese ngultrum'],
        ['BWP', 'BWP - Botswana pula'],
        ['BYN', 'BYN - Belarusian ruble'],
        ['BZD', 'BZD - Belize dollar'],
        ['CAD', 'CAD - Canadian dollar'],
        ['CDF', 'CDF - Congolese franc'],
        ['CHF', 'CHF - Swiss franc'],
        ['CLP', 'CLP - Chilean peso'],
        ['CNY', 'CNY - Renminbi/Chinese yuan'],
        ['COP', 'COP - Colombian peso'],
        ['CRC', 'CRC - Costa Rican colón'],
        ['CUP', 'CUP - Cuban peso'],
        ['CVE', 'CVE - Cape Verdean escudo'],
        ['CZK', 'CZK - Czech koruna'],
        ['DJF', 'DJF - Djiboutian franc'],
        ['DKK', 'DKK - Danish krone'],
        ['DOP', 'DOP - Dominican peso'],
        ['DZD', 'DZD - Algerian dinar'],
        ['EGP', 'EGP - Egyptian pound'],
        ['ERN', 'ERN - Eritrean nakfa'],
        ['ETB', 'ETB - Ethiopian birr'],
        ['EUR', 'EUR - Euro'],
        ['FJD', 'FJD - Fijian dollar'],
        ['FKP', 'FKP - Falkland Islands pound'],
        ['GBP', 'GBP - Sterling'],
        ['GEL', 'GEL - Georgian lari'],
        ['GHS', 'GHS - Ghanaian cedi'],
        ['GIP', 'GIP - Gibraltar pound'],
        ['GMD', 'GMD - Gambian dalasi'],
        ['GNF', 'GNF - Guinean franc'],
        ['GTQ', 'GTQ - Guatemalan quetzal'],
        ['GYD', 'GYD - Guyanese dollar'],
        ['HKD', 'HKD - Hong Kong dollar'],
        ['HNL', 'HNL - Honduran lempira'],
        ['HRK', 'HRK - Croatian kuna'],
        ['HTG', 'HTG - Haitian gourde'],
        ['HUF', 'HUF - Hungarian forint'],
        ['IDR', 'IDR - Indonesian rupiah'],
        ['ILS', 'ILS - Israeli new shekel'],
        ['INR', 'INR - Indian rupee'],
        ['IQD', 'IQD - Iraqi dinar'],
        ['IRR', 'IRR - Iranian rial'],
        ['ISK', 'ISK - Icelandic króna'],
        ['JMD', 'JMD - Jamaican dollar'],
        ['JOD', 'JOD - Jordanian dinar'],
        ['JPY', 'JPY - Japanese yen'],
        ['KES', 'KES - Kenyan shilling'],
        ['KGS', 'KGS - Kyrgyz som'],
        ['KHR', 'KHR - Cambodian riel'],
        ['KMF', 'KMF - Comorian franc'],
        ['KPW', 'KPW - North Korean won'],
        ['KRW', 'KRW - South Korean won'],
        ['KWD', 'KWD - Kuwaiti dinar'],
        ['KYD', 'KYD - Cayman Islands dollar'],
        ['KZT', 'KZT - Kazakhstani tenge'],
        ['LAK', 'LAK - Lao kip'],
        ['LBP', 'LBP - Lebanese pound'],
        ['LKR', 'LKR - Sri Lankan rupee'],
        ['LRD', 'LRD - Liberian dollar'],
        ['LSL', 'LSL - Lesotho loti'],
        ['LYD', 'LYD - Libyan dinar'],
        ['MAD', 'MAD - Moroccan dirham'],
        ['MDL', 'MDL - Moldovan leu'],
        ['MGA', 'MGA - Malagasy ariary'],
        ['MKD', 'MKD - Macedonian denar'],
        ['MMK', 'MMK - Burmese kyat'],
        ['MNT', 'MNT - Mongolian tögrög'],
        ['MOP', 'MOP - Macanese pataca'],
        ['MRU', 'MRU - Mauritanian ouguiya'],
        ['MUR', 'MUR - Mauritian rupee'],
        ['MVR', 'MVR - Maldivian rufiyaa'],
        ['MWK', 'MWK - Malawian kwacha'],
        ['MXN', 'MXN - Mexican peso'],
        ['MYR', 'MYR - Malaysian ringgit'],
        ['MZN', 'MZN - Mozambican metical'],
        ['NAD', 'NAD - Namibian dollar'],
        ['NGN', 'NGN - Nigerian naira'],
        ['NIO', 'NIO - Nicaraguan córdoba'],
        ['NOK', 'NOK - Norwegian krone'],
        ['NPR', 'NPR - Nepalese rupee'],
        ['NZD', 'NZD - New Zealand dollar'],
        ['OMR', 'OMR - Omani rial'],
        ['PAB', 'PAB - Panamanian balboa'],
        ['PEN', 'PEN - Peruvian sol'],
        ['PGK', 'PGK - Papua New Guinean kina'],
        ['PHP', 'PHP - Philippine peso'],
        ['PKR', 'PKR - Pakistani rupee'],
        ['PLN', 'PLN - Polish złoty'],
        ['PYG', 'PYG - Paraguayan guaraní'],
        ['QAR', 'QAR - Qatari riyal'],
        ['RON', 'RON - Romanian leu'],
        ['RSD', 'RSD - Serbian dinar'],
        ['RUB', 'RUB - Russian ruble'],
        ['RWF', 'RWF - Rwandan franc'],
        ['SAR', 'SAR - Saudi riyal'],
        ['SBD', 'SBD - Solomon Islands dollar'],
        ['SCR', 'SCR - Seychellois rupee'],
        ['SDG', 'SDG - Sudanese pound'],
        ['SEK', 'SEK - Swedish krona'],
        ['SGD', 'SGD - Singapore dollar'],
        ['SHP', 'SHP - Saint Helena pound'],
        ['SLL', 'SLL - Sierra Leonean leone'],
        ['SOS', 'SOS - Somali shilling'],
        ['SRD', 'SRD - Surinamese dollar'],
        ['SSP', 'SSP - South Sudanese pound'],
        ['STN', 'STN - São Tomé and Príncipe dobra'],
        ['SYP', 'SYP - Syrian pound'],
        ['SZL', 'SZL - Swazi lilangeni'],
        ['THB', 'THB - Thai baht'],
        ['TJS', 'TJS - Tajikistani somoni'],
        ['TMT', 'TMT - Turkmenistan manat'],
        ['TND', 'TND - Tunisian dinar'],
        ['TOP', 'TOP - Tongan paʻanga[O]'],
        ['TRY', 'TRY - Turkish lira'],
        ['TTD', 'TTD - Trinidad and Tobago dollar'],
        ['TWD', 'TWD - New Taiwan dollar'],
        ['TZS', 'TZS - Tanzanian shilling'],
        ['UAH', 'UAH - Ukrainian hryvnia'],
        ['UGX', 'UGX - Ugandan shilling'],
        ['USD', 'USD - United States dollar'],
        ['UYU', 'UYU - Uruguayan peso'],
        ['UZS', 'UZS - Uzbekistani soʻm'],
        ['VES', 'VES - Venezuelan sovereign bolívar'],
        ['VND', 'VND - Vietnamese đồng'],
        ['VUV', 'VUV - Vanuatu vatu'],
        ['WST', 'WST - Samoan tālā'],
        ['XAF', 'XAF - Central African CFA franc'],
        ['XCD', 'XCD - Eastern Caribbean dollar'],
        ['XOF', 'XOF - West African CFA franc'],
        ['XPF', 'XPF - CFP franc'],
        ['YER', 'YER - Yemeni rial'],
        ['ZAR', 'ZAR - South African rand'],
        ['ZMW', 'ZMW - Zambian kwacha'],
        ['ZWL', 'ZWL - Zimbabwe'],
        ['XDR', 'XDR - IMF [Special drawing right]'],
        ['XAU', 'XAU - Gold'],
        ['XAG', 'XAG - Silver'],
        ['SVC', 'SVC - Salvadoran colón'],
        ['STD', 'STD - São Tomé and Príncipe dobra'],
        ['MRO', 'MRO - Mauritanian ouguiya'],
        ['LVL', 'LVL - Latvian lats'],
        ['LTL', 'LTL - Lithuanian litas'],
        ['CUC', 'CUC - Cuban convertible peso'],
        ['CLF', 'CLF - Unidad de Fomento (funds code)'],
        ['BYR', 'BYR - Belarusian ruble'],
        ['ZMK', 'ZMK - Zambian kwacha']
    ]);

// Translations pulled from https://fr.wikipedia.org/wiki/Liste_des_monnaies_en_circulation
export const currencyNameMapFr = new Map<string, string>(
    [
        ['AED', 'AED - Dirham des Émirats arabes unis'],
        ['AFN', 'AFN - Afghani'],
        ['ALL', 'ALL - Lek albanais'],
        ['AMD', 'AMD - Dram'],
        ['ANG', 'ANG - Florin des Antilles néerlandaises'],
        ['AOA', 'AOA - Kwanza'],
        ['ARS', 'ARS - Peso argentin'],
        ['AUD', 'AUD - Dollar australien'],
        ['AWG', 'AWG - Florin arubais'],
        ['AZN', 'AZN - Manat azerbaïdjanais'],
        ['BAM', 'BAM - Mark convertible'],
        ['BBD', 'BBD - Dollar barbadien'],
        ['BDT', 'BDT - Taka'],
        ['BGN', 'BGN - Lev bulgare'],
        ['BHD', 'BHD - Dinar de Bahreïn'],
        ['BIF', 'BIF - Franc burundais'],
        ['BMD', 'BMD - Dollar des Bermudes'],
        ['BND', 'BND - Dollar de Brunei'],
        ['BOB', 'BOB - Boliviano bolivien'],
        ['BRL', 'BRL - Réal brésilien'],
        ['BSD', 'BSD - Dollar des Bahamas'],
        ['BTN', 'BTN - Ngultrum'],
        ['BWP', 'BWP - Pula'],
        ['BYN', 'BYN - Rouble biélorusse'],
        ['BZD', 'BZD - Dollar de Belize'],
        ['CAD', 'CAD - Dollar canadien'],
        ['CDF', 'CDF - Franc congolais'],
        ['CHF', 'CHF - Franc suisse'],
        ['CLP', 'CLP - Peso chilien'],
        ['CNY', 'CNY - Yuan renminbi'],
        ['COP', 'COP - Peso colombien'],
        ['CRC', 'CRC - Colon du Costa Rica'],
        ['CUP', 'CUP - Peso cubain'],
        ['CVE', 'CVE - Escudo du Cap-Vert'],
        ['CZK', 'CZK - Couronne tchèque'],
        ['DJF', 'DJF - Franc de Djibouti'],
        ['DKK', 'DKK - Couronne danoise'],
        ['DOP', 'DOP - Peso dominicain'],
        ['DZD', 'DZD - Dinar algérien'],
        ['EGP', 'EGP - Livre égyptienne'],
        ['ERN', 'ERN - Nakfa'],
        ['ETB', 'ETB - Birr'],
        ['EUR', 'EUR - Euro'],
        ['FJD', 'FJD - Dollar des Fidji'],
        ['FKP', 'FKP - Livre des îles Malouines'],
        ['GBP', 'GBP - Livre sterling'],
        ['GEL', 'GEL - Lari'],
        ['GHS', 'GHS - Cedi'],
        ['GIP', 'GIP - Livre de Gibraltar'],
        ['GMD', 'GMD - Dalasi'],
        ['GNF', 'GNF - Franc guinéen'],
        ['GTQ', 'GTQ - Quetzal'],
        ['GYD', 'GYD - Dollar guyanien'],
        ['HKD', 'HKD - Dollar de Hong Kong'],
        ['HNL', 'HNL - Lempira'],
        ['HRK', 'HRK - Kuna'],
        ['HTG', 'HTG - Gourde haïtienne'],
        ['HUF', 'HUF - Forint hongrois'],
        ['IDR', 'IDR - Rupiah'],
        ['ILS', 'ILS - Shekel'],
        ['INR', 'INR - Roupie indienne'],
        ['IQD', 'IQD - Dinar irakien'],
        ['IRR', 'IRR - Rial iranien'],
        ['ISK', 'ISK - Couronne islandaise'],
        ['JMD', 'JMD - Dollar jamaïcain'],
        ['JOD', 'JOD - Dinar jordanien'],
        ['JPY', 'JPY - Yen'],
        ['KES', 'KES - Shilling kényan'],
        ['KGS', 'KGS - Som'],
        ['KHR', 'KHR - Riel'],
        ['KMF', 'KMF - Franc comorien'],
        ['KPW', 'KPW - Won nord-coréen'],
        ['KRW', 'KRW - Won sud-coréen'],
        ['KWD', 'KWD - Dinar koweïtien'],
        ['KYD', 'KYD - Dollar des îles Caïmans'],
        ['KZT', 'KZT - Tenge'],
        ['LAK', 'LAK - Kip'],
        ['LBP', 'LBP - Livre libanaise'],
        ['LKR', 'LKR - Roupie srilankaise'],
        ['LRD', 'LRD - Dollar libérien'],
        ['LSL', 'LSL - Loti'],
        ['LYD', 'LYD - Dinar libyen'],
        ['MAD', 'MAD - Dirham marocain'],
        ['MDL', 'MDL - Leu moldave'],
        ['MGA', 'MGA - Ariary'],
        ['MKD', 'MKD - Denar'],
        ['MMK', 'MMK - Kyat'],
        ['MNT', 'MNT - Tugrik'],
        ['MOP', 'MOP - Pataca'],
        ['MRU', 'MRU - Ouguiya'],
        ['MUR', 'MUR - Roupie mauricienne'],
        ['MVR', 'MVR - Rufiyaa'],
        ['MWK', 'MWK - Kwacha malawien'],
        ['MXN', 'MXN - Peso mexicain'],
        ['MYR', 'MYR - Ringgit'],
        ['MZN', 'MZN - Metical'],
        ['NAD', 'NAD - Dollar namibien'],
        ['NGN', 'NGN - Naira'],
        ['NIO', 'NIO - Córdoba oro'],
        ['NOK', 'NOK - Couronne norvégienne'],
        ['NPR', 'NPR - Roupie népalaise'],
        ['NZD', 'NZD - Dollar néo-zélandais'],
        ['OMR', 'OMR - Rial omanais'],
        ['PAB', 'PAB - Balboa'],
        ['PEN', 'PEN - Nuevo sol péruvien'],
        ['PGK', 'PGK - Kina'],
        ['PHP', 'PHP - Peso philippin'],
        ['PKR', 'PKR - Roupie pakistanaise'],
        ['PLN', 'PLN - Złoty polonais'],
        ['PYG', 'PYG - Guaraní paraguayen'],
        ['QAR', 'QAR - Riyal qatari'],
        ['RON', 'RON - Leu roumain'],
        ['RSD', 'RSD - Dinar serbe'],
        ['RUB', 'RUB - Rouble russe'],
        ['RWF', 'RWF - Franc rwandais'],
        ['SAR', 'SAR - Riyal saoudien'],
        ['SBD', 'SBD - Dollar des îles Salomon'],
        ['SCR', 'SCR - Roupie seychelloise'],
        ['SDG', 'SDG - Livre soudanaise'],
        ['SEK', 'SEK - Couronne suédoise'],
        ['SGD', 'SGD - Dollar de Singapour'],
        ['SHP', 'SHP - Livre de Sainte-Hélène'],
        ['SLL', 'SLL - Leone'],
        ['SOS', 'SOS - Shilling somalien'],
        ['SRD', 'SRD - Dollar du Suriname'],
        ['SSP', 'SSP - Livre sud-soudanaise'],
        ['STN', 'STN - Dobra'],
        ['SYP', 'SYP - Livre syrienne'],
        ['SZL', 'SZL - Lilangeni'],
        ['THB', 'THB - Baht'],
        ['TJS', 'TJS - Somoni'],
        ['TMT', 'TMT - Manat turkmène'],
        ['TND', 'TND - Dinar tunisien'],
        ['TOP', 'TOP - Paʻanga'],
        ['TRY', 'TRY - Livre turque'],
        ['TTD', 'TTD - Dollar trinidadien'],
        ['TWD', 'TWD - Nouveau dollar de Taïwan'],
        ['TZS', 'TZS - Shilling tanzanien'],
        ['UAH', 'UAH - Hryvnia'],
        ['UGX', 'UGX - Shilling ougandais'],
        ['USD', 'USD - Dollar américain'],
        ['UYU', 'UYU - Peso uruguayen'],
        ['UZS', 'UZS - Sum'],
        ['VES', 'VES - Bolívar vénézuélien'],
        ['VND', 'VND - Dong'],
        ['VUV', 'VUV - Vatu'],
        ['WST', 'WST - Tala'],
        ['XAF', 'XAF - Franc CFA de la CEMAC'],
        ['XCD', 'XCD - Dollar des Caraïbes orientales'],
        ['XOF', 'XOF - Franc CFA du UEMOA'],
        ['XPF', 'XPF - Franc pacifique'],
        ['YER', 'YER - Riyal yéménite'],
        ['ZAR', 'ZAR - Rand'],
        ['ZMW', 'ZMW - Kwacha de Zambie'],
        ['ZWL', 'ZWL - Dollar du Zimbabwe'],
        ['XDR', 'XDR - Droits de tirage spéciaux (DTS)'],
        ['XAU', 'XAU - Or'],
        ['XAG', 'XAG - Argent'],
        ['SVC', 'SVC - Colon'],
        ['STD', 'STD - Dobra'],
        ['MRO', 'MRO - Ouguiya'],
        ['LVL', 'LVL - Lats'],
        ['LTL', 'LTL - Litas'],
        ['CUC', 'CUC - Peso cubain convertible'],
        ['CLF', 'CLF - Unité d’investissement'],
        ['BYR', 'BYR - Rouble (2e)'],
        ['ZMK', 'ZMK - Kwacha']
    ]);

